import { Bugsnag } from "@bugsnag/js";

import bugsnag from "./bugsnag";

const notifyOptions: Bugsnag.INotifyOpts = {
  beforeSend(report) {
    // remove the call to logger from the stack trace for better error grouping
    report.stacktrace = report.stacktrace.slice(1);
  },
};

export function error(message: any, metaData?: any) {
  // tslint:disable-next-line: no-console
  console.error(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), {
      ...notifyOptions,
      severity: "error",
      metaData,
    });
  }
}

export function warning(message: any, metaData?: any) {
  // tslint:disable-next-line: no-console
  console.warn(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), {
      ...notifyOptions,
      severity: "warning",
      metaData,
    });
  }
}

export function info(message: any, metaData?: any) {
  // tslint:disable-next-line: no-console
  console.info(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), {
      ...notifyOptions,
      severity: "info",
      metaData,
    });
  }
}

export function breadcrumb(name: string, metaData?: any, type?: string) {
  if (bugsnag) {
    bugsnag.leaveBreadcrumb(name, metaData, type);
  }
}

function normalizeMessage(message: any): string | Error {
  if (message instanceof Error) {
    return message;
  }

  if (typeof message === "object") {
    return message.error_description || message.error || message.message || JSON.stringify(message);
  }

  return message.toString();
}
